<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="用户账号" prop="myUserId">
                <GridSelect
                    style="width: 180px"
                    title="选择用户"
                    labelName="userName"
                    labelValue="id"
                    :value="queryForm.userName"
                    :limit="1"
                    size="small"
                    placeholder="请选择用户"
                    @getValue="
                        (value) => {
                            queryForm.userName = value;
                        }
                    "
                    :columns="USER_code"
                    :searchs="USER_search"
                    dataListUrl="/mpp/user/findList"
                    entityBeanName="mppUser"
                    queryEntityUrl="/mpp/user/get"
                >
                </GridSelect>
            </el-form-item>
            <el-form-item label="用户别名">
                <el-input v-model="queryForm.userNickname" placeholder="请填写用户别名" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item label="用户邮箱">
                <el-input v-model="queryForm.userEmail" placeholder="请填写用户邮箱" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 80px">
                <el-button size="small" type="primary" icon="el-icon-search" @click="getFriendList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group"></div>
                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshFriendList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!--用户好友列表-->
            <el-table
                :data="friendList"
                width="100%"
                row-key="id"
                size="small"
                height="50%"
                @selection-change="handleSelectionChange"
                :default-expand-all="true"
            >
                <el-table-column align="center" type="selection" min-width="5%"> </el-table-column>
                <el-table-column  align="center" label="用户账号" prop="userName" min-width="10%"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="userNickname" label="用户别称" min-width="10%">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="userRealname" label="用户真名" min-width="10%">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="userEmail" label="用户邮箱" min-width="10%">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="userMobile" label="用户手机" min-width="10%">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" label="创建时间" min-width="12%">
                    <template slot-scope="scpe">
                        {{ $moment(scpe.row.createTime).format('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    fixed='right'
                    align='center'
                    label='操作'
                    min-width="10%"
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <div @click='Silenced(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>解禁</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog :title="shopMoneyRecordStates[shopMoneyRecordState]" :visible.sync="showDialog" width="60%" @close="closeDialog">
                <div>
                    <el-form
                        :model="shopMoneyRecord"
                        ref="shopMoneyRecordForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="mini"
                    >
                        <el-form-item label="所属用户" prop="userId">
                            <el-input size="small" v-model="shopMoneyRecord.userId" :disabled="shopMoneyRecordState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="金额" prop="money">
                            <el-input size="small" v-model="shopMoneyRecord.money" :disabled="shopMoneyRecordState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="记录详情" prop="recordDetail">
                            <el-input
                                size="small"
                                v-model="shopMoneyRecord.recordDetail"
                                :disabled="shopMoneyRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="记录类型" prop="recordType">
                            <el-input
                                size="small"
                                v-model="shopMoneyRecord.recordType"
                                :disabled="shopMoneyRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="记录状态" prop="recordStatus">
                            <el-input
                                size="small"
                                v-model="shopMoneyRecord.recordStatus"
                                :disabled="shopMoneyRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="目标Id" prop="targetId">
                            <el-input
                                size="small"
                                v-model="shopMoneyRecord.targetId"
                                :disabled="shopMoneyRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="目标类型" prop="targetType">
                            <el-input
                                size="small"
                                v-model="shopMoneyRecord.targetType"
                                :disabled="shopMoneyRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <!-- <el-button
            type="primary"
            @click="submitForm"
            v-if="shopMoneyRecordState != 'check'"
          >确定</el-button> -->
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from "@/utils/constant"
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetFriendList();
                this.getFriendList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetFriendList();
                this.getFriendList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            timeRange: [],
            queryForm: {
                userEmail: '', //所属用户
                userHeader: '', //金额
                userMobile: '', //记录详情
                userName: '', //记录类型
                userNickname: '', //记录状态
                userRealname: '', //目标Id
                startTime: '',
                endTime: ''
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopMoneyRecordState: 'add',
            shopMoneyRecordStates: {
                add: '新建账户',
                check: '查看账户',
                edit: '修改账户'
            },

            multipleSelection: [],
            friendList: [],
            shopMoneyRecord: {
                id: '', //ID
                userEmail: '', //所属用户
                userHeader: '', //金额
                userMobile: '', //记录详情
                userName: '', //记录类型
                userNickname: '', //记录状态
                userRealname: '', //目标Id
            },
            btnLoading: false,
            multipleSelection:[],
            rules: {}
        };
    },
    created() {
        this.getFriendList();
    },
    methods: {
        Silenced(id){
            this.$confirm('确定要解禁吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    get(`/im/user/removeForbidden`, { userId : id }).then((res) => {
                        if(res.success){
                            this.$message.success(res.msg);
                            this.getFriendList()
                        }else{
                            this.$message.error(res.msg);
                        }
                    });
                })
                .catch(() => {
                    console.log('cancel');
                });
        },
        deleteFriend(mallShopId) {
            let ids = '';
            console.log(mallShopId)
            if (mallShopId) {
                ids = mallShopId;
            } else {
                ids = this.multipleSelection.map((mallShop) => mallShop.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/im/friend/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetFriendList();
                            this.getFriendList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetFriendList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.friendList = [];
        },
        resetDialog() {
            this.shopMoneyRecordState = 'add';
            this.showDialog = false;
            this.queryForm = {
                myUserId: '', //用户id
                friendUserId: '', //好友用户id
                startTime: '', //开始时间
                endTime: '' //结束时间
            };
            this.timeRange = [];
            this.getFriendList();
        },
        closeDialog() {
            this.resetDialog();
        },

        checkFriend(shopMoneyRecordId) {},
        refreshFriendList() {
            this.resetFriendList();
            this.getFriendList();
        },
        getFriendList() {
            this.loading = true;
            if (this.timeRange != null) {
                this.queryForm.startTime = this.timeRange[0];
                this.queryForm.endTime = this.timeRange[1];
            }
            get(`/im/user/findForbiddenList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.friendList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getFriendList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getFriendList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.moneyRecord-table-expand {
    font-size: 0;
    margin-top: -20px;
}
.moneyRecord-table-expand label {
    width: 90px;
    color: #99a9bf;
}
.moneyRecord-table-expand .el-form-item {
    margin-left: 4%;
    margin-bottom: -1%;
    width: 100%;
}
</style>
